import {type IAsset} from '../schema';
import {assetCheckedOut} from './assetCheckedOut';

export const assetNotCheckedOut = (asset?: IAsset) => !assetCheckedOut(asset);
